<script>
export default {
    name: "register",
    data() {
        return {
            username: '',
            password: '',
            isShowPassword: false,
            passwordAgain: '',
            isShowPasswordAgain: false,
            email: '',
            phone: '',
            code: '',
            isCodeLoading: false,
            countdown: 0,
            time: null,
            isLoading:false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 设置倒计时
        setCountdown() { 
            this.countdown = 59;
            if(this.time) clearInterval(this.time);
            this.time = setInterval(() => {
                this.countdown--;
                if(this.countdown <= 0) clearInterval(this.time);
            }, 1000)
        },
        // 获取验证码
        getCode() { 
            if (this.isCodeLoading) { 
                return;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            this.isCodeLoading = true;
            this.$store.dispatch('getCode', {
                phone: this.phone,
                type: 1
            }).then((result) => {
                this.isCodeLoading = false;
                if (result.code == 100) {
                    this.setCountdown();
                    this.$showToast({ text: '验证码已发送' });
                } else if (result.code == 101) { 
                    this.$showToast({ text: '验证码发送失败' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '已发送验证码，请勿重复获取' });
                    this.setCountdown();
                }
            }).catch((err) => {
                this.isCodeLoading = false;
                this.$showToast({ text: '验证码发送失败' });
            });
        },
        // 注册
        submit() {
            if (this.isLoading) {
                return;
            }
            if(this.username.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.username.focus();
                this.$showToast({ text: '请输入用户名' });
                return false;
            }
            if(this.password.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.password.focus();
                this.$showToast({ text: '请输入密码' });
                return false;
            }
            if(this.passwordAgain.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.passwordAgain.focus();
                this.$showToast({ text: '请再输入密码' });
                return false;
            }
            if(this.password != this.passwordAgain){
                this.$refs.passwordAgain.focus();
                this.$showToast({ text: '两次密码不一致' });
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: '请输入邮箱' });
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: '邮箱格式有误' }); //邮箱格式有误
                return false;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            if(this.code.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.code.focus();
                this.$showToast({ text: '请输入验证码' });
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('reg', {
                username: this.username,
                password: this.password,
                confirm_password: this.passwordAgain,
                email: this.email,
                phone: this.phone,
                code: this.code,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    localStorage.setItem('token', result.data.token);
                    this.$store.state.isLogin = true;
                    this.$store.state.userinfo = result.data.userinfo;
                    if (this.$route.query.redirect) {
                        this.$router.replace(this.$route.query.redirect);
                    } else {
                        this.$router.replace('/');
                    }
                } else if (result.code == 101) { 
                    this.$showToast({ text: '用户名或者手机号已经被注册' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '验证码错误' });
                } else if (result.code == 103) { 
                    this.$showToast({ text: '两次密码不一致' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '注册失败' });
            });
        },
    },
};
</script>

<template>
    <div class="layout_mine flex flex_column justify_center">
        <p class="title">创建一个帐户</p>
        <p class="desc">使用Ambassador<sup>+</sup>帐户，您可以查看过去的订单并存储不同的送货地址 并且下次您可以更快地结账。</p>
        <div class="form">
            <div class="input_group required">
                <input type="text" placeholder="请输入用户名" ref="username" v-model="username"/>
            </div>
            <div class="input_group required">
                <input class="password" :type="isShowPassword ? 'text' : 'password'" placeholder="请输入密码" ref="password" v-model="password"/>
                <div class="btn_switch_password" :class="{active: isShowPassword}" @click="isShowPassword = !isShowPassword"></div>
            </div>
            <div class="input_group required">
                <input class="password" :type="isShowPasswordAgain ? 'text' : 'password'" placeholder="请再输入密码" ref="passwordAgain" v-model="passwordAgain"/>
                <div class="btn_switch_password" :class="{active: isShowPasswordAgain}" @click="isShowPasswordAgain = !isShowPasswordAgain"></div>
            </div>
            <div class="input_group required">
                <input type="email" placeholder="请输入邮箱" ref="email" v-model="email"/>
            </div>
            <div class="input_group required">
                <input type="tel" placeholder="请输入手机号" ref="phone" v-model="phone"/>
            </div>
            <div class="input_group required">
                <input type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="6"/>
                <div class="btn btn_code layout_flex_center" v-if="isCodeLoading">
                    <Loading  type="smail"/>
                </div>
                <div class="btn btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                <div class="btn btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
            </div>
            <div class="input_group">
                <div class="btn layout_flex_center" @click="submit">注册</div>
            </div>
            <!-- <p class="tip">*为必填选项</p> -->
            <p class="tip center">已有账号，<router-link :to="{ path: '/login', query: $route.query }">立即登录</router-link></p>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import '~@/assets/css/mineForm.scss';
</style>